var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('TopCtrl'),_vm._v(" "),_c('EmptyListTip',{attrs:{"icon":"//res.uuudian.com/hk_data/573136ab-6c83-4cb1-8125-9f124913cb1c","text":"登录会话已过期，请重新登录","primaryButton":"重新登录"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523dcf2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/public/NoAuth.vue
// module id = null
// module chunks = 